// Allows dragging dynamic builder elements via a context menu button
export default function () {
  return {
    restrict: 'A',
    link: function(_s, element, _a) {
      element.attr('draggable', true);
      element.on('dragstart', function(e) {
        const dt = e.originalEvent?.dataTransfer || e.dataTransfer;
        if (!dt) return;
        dt.setData('text/plain', 'builder-drag-menu');
        dt.effectAllowed = 'copy';
      });
    }
  };
};
